import React, { useState, useEffect, useContext } from "react";
import { withStyles } from "@material-ui/core";
import ModalDialogContext from "../../../../../../Context/ModalDialog/ModalDialogContext";
import LoadingIndicator from "../../../../../../Component/LoadingIndicator";
import {
  getCountryRiskDataRanges,
  updateCountryRiskDataRange,
} from "../../../../../../API/Country";
import { recordTypes } from "../../../../../../API/config";
import CountryRiskDataRangesTable from "./CountryRiskDataRangesTable";

import { styles } from "./styles";

const CountryRiskDataRanges = (props) => {
  const { classes,hasPermission } = props;
  const [riskDataRanges, setRiskDataRanges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState();

  const { showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    const evalPermissions = async () => {
      const canEdit = await hasPermission(recordTypes.countryRiskData.name, recordTypes.countryRiskData.actions.update.name);
      setCanEdit(canEdit);
    };

    evalPermissions();
  }, []);

  useEffect(() => {
    loadRiskDataRanges();
  }, []);

  const loadRiskDataRanges = async () => {
    try {
      setLoading(true);
      const result = await getCountryRiskDataRanges();
      const { data = [] } = result;
      setRiskDataRanges(data);
      setLoading(false);
    } catch (error) {
      showErrorMessage({ error });
      setLoading(false);
    }
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const updateRiskDataRange = async (riskDataRangeNewData) => {
    try {
      const data = {
        section: riskDataRangeNewData.section,
        lowFrom: String(riskDataRangeNewData.low_from),
        lowTo: String(riskDataRangeNewData.low_to),
        mediumFrom: String(riskDataRangeNewData.medium_from),
        mediumTo: String(riskDataRangeNewData.medium_to),
        highFrom: String(riskDataRangeNewData.high_from),
        highTo: String(riskDataRangeNewData.high_to),
      };

      await updateCountryRiskDataRange(data);
      await loadRiskDataRanges();
    } catch (error) {
      showErrorMessage({ error });
    }
  };

  return (
    <>
      {loading ? (
        renderLoadingIndicator()
      ) : (
        <div className={classes.tableContainer}>
          <CountryRiskDataRangesTable
            loading={loading}
            riskDataRanges={riskDataRanges}
            onUpdateRecord={updateRiskDataRange}
            canEdit={canEdit}
          />
        </div>
      )}
    </>
  );
};

export default withStyles(styles, { withTheme: true })(CountryRiskDataRanges);
